import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
import primeHelper from '../utils/prime-helper';
import _ from 'lodash';
import Cons from '../../isomorphic/cons';
import AgentTcView from './agent-tc-view';
import AgentAdminView from './agent-admin-view';
import Notifications from '../utils/notification-helper';

const AsyncTypeahead = asyncContainer(Typeahead);

@inject('appStore')
@observer
export default class AgentView extends Component {
    constructor(props) {
        super(props);
    }

    renderAgentItem(option, props, index) {
        return (
            <div key={option.agentContactId}>
                <button
                    style={{ marginRight: '10px' }}
                    className="btn btn-default btn-sm"
                    onClick={this.handleSkySlopeButtonClick.bind(this, option)}
                >
                    SkySlope
                </button>
                <span>
                    <strong>{option.name}</strong> ({option.email}) {option.company}
                </span>
            </div>
        );
    }

    handleSkySlopeButtonClick(agent, e) {
        //appStore.analytics.track("Agent Login-As Selected", {agent: agent})
        e.stopPropagation();
        primeHelper.logInAsAgent(agent.email, agent.agentContactId, appStore.viewStore.selectedTab);
    }

    lookupAgentSelected(selectedAgent) {
        // appStore.analytics.track("Agent Search Selected", {selectedAgent: selectedAgent})

        if (selectedAgent && selectedAgent.length > 0) {
            appStore.agentStore
                .addWatchAgent(_.head(selectedAgent))
                .then(() => {
                    appStore.agentStore.loadWatchAgents();
                    this.refs.agentTypeahead.getInstance().clear();
                })
                .catch(err => {
                    Notifications.ToastError(err.message);
                });
        }
    }

    handleClick(agent) {
        // appStore.analytics.track("Agent Login-As Selected", {agent: agent})
        primeHelper.logInAsAgent(agent.email, agent.agentContactId, appStore.viewStore.selectedTab);
    }

    handleWatchAgentRemove(agent, e) {
        // appStore.analytics.track("Agent Watch Removed", {agent: agent})
        e.stopPropagation();
        appStore.agentStore.removeWatchAgent(agent).then(() => {
            appStore.agentStore.loadWatchAgents();
        });
    }

    handleOpenProfile(agent, e) {
        // appStore.analytics.track("Agent Profile Selected", {agent: agent})
        e.stopPropagation();
        appStore.viewStore.openAgentProfilePageById(
            Cons.pages.agents,
            agent.agentContactId,
            agent.subscriberId,
            agent.subscriberName
        );
    }

    render() {
        const user = this.props.appStore.coordinatorDetailStore.coordinator;
        return (
            <div className="tab-pane active agent-view">
                <div className="row form-group">
                    <div className="col-sm-12">
                        <AsyncTypeahead
                            ref="agentTypeahead"
                            options={appStore.agentStore.lookupAgentsComputed || []}
                            {...this.props}
                            appStore={appStore}
                            labelKey="name"
                            placeholder="Search agents"
                            minLength={2}
                            filterBy={
                                () => {
                                    return true;
                                } /* just return the results rom elastic search */
                            }
                            onSearch={appStore.agentStore.loadLookupAgents}
                            renderMenuItemChildren={this.renderAgentItem.bind(this)}
                            onChange={this.lookupAgentSelected.bind(this)}
                        />
                    </div>
                </div>
                {user.hasRole('admin') || user.hasRole('superadmin') ? (
                    <AgentAdminView
                        handleOpenProfile={this.handleOpenProfile}
                        handleClick={this.handleClick}
                        handleWatchAgentRemove={this.handleWatchAgentRemove}
                    />
                ) : (
                    <AgentTcView
                        handleOpenProfile={this.handleOpenProfile}
                        handleClick={this.handleClick}
                        handleWatchAgentRemove={this.handleWatchAgentRemove}
                    />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/agents/agent-view.js